
// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Link } from 'react-router-dom';

// const Crime = () => {
//     const [data, setData] = useState({});
//     const [loading, setLoading] = useState(true);

//     // Define default static data matching the backend structure (assuming similar to Country/Politics)
//     const defaultData = {
//         main_news: {
//             featured: {
//                 title: "अपराध",
//                 category: "यमुनोत्री जाते समय चलती कार में गिरा पहाड़: 3 लोग सवार, बिहार से आए दर्शन करने; रेस्क्यू ऑपरेशन जारी – Uttarkashi News",
//                 date: "2017-03-22T17:49",
//                 image: "/assets/img/ezgif-5530dd1da8b37c_1759988348.webp"
//             },
//             list: [
//                 {
//                     title: "जहरीला कफ सिरप बनाने वाली कंपनी का डायरेक्टर गिरफ्तार:– Madhya Pradesh",
//                     image: "/assets/img/live-update-centre-2025-10-09t081936484_1759978108.webp",
//                     category: "News",
//                     date: "2017-03-22T17:50",
//                     description: "मध्य प्रदेश में 23 बच्चों की मौत का कारण बने कोल्ड्रिफ कफ सिरप बनाने वाली कंपनी श्रीसन फार्मा का डायरेक्टर गोविंदन रंगनाथन गिरफ्तार कर लिया गया है। मामले में मध्य प्रदेश सरकार द्वारा बनाई गई SIT की टीम ने बुधवार-गुरुवार की दरमियानी रात तमिलनाडु के...."
//                 },
//                 {
//                     title: "हरियाणा IPS सुसाइड केस; 2 धड़ों में बंटे अफसर:– Chandigarh News",
//                     image: "/assets/img/ezgif-25eec5267e400a_1759978236.webp",
//                     category: "News",
//                     date: "2017-03-22T02:34",
//                     description: "हरियाणा के IPS अफसर IG वाई पूरन कुमार का सुसाइड केस अब तूल पकड़ता दिख रहा है। इस मामले में IPS-IAS अफसरों के साथ ही HCS और HPS अफसर भी दो धड़ों में बंटे हैं। एससी वर्ग के अफसर वाई पूरन कुमार को न्याय दिलाने के लिए लामबंद हो रहे हैं।....."
//                 },
//                 {
//                     title: "नागपुर से मिला था छिंदवाड़ा को ‘मौत का अलर्ट:– Madhya Pradesh News",
//                     image: "/assets/img/11-1_1759952360.webp",
//                     category: "News",
//                     date: "2017-03-22T02:34",
//                     description: "छिंदवाड़ा में कोल्ड्रिफ कफ सिरप से हुई बच्चों की मौतों को टाला जा सकता था, यदि जिला प्रशासन नागपुर से मिले अलर्ट को सीरियसली लेता। दरअसल, नागपुर के कलर्स अस्पताल के संचालक डॉ. राजेश अग्रवाल ने 15 सितंबर को ही परासिया के स्थानीय पार्षद अनुज पाटकर को....."
//                 }
//             ]
//         },

//     };

//     useEffect(() => {
//         let mounted = true;
//         const fetchData = async () => {
//             try {
//                 console.log("Fetching crime data...");
//                 const res = await axios.get(`${process.env.REACT_APP_BASE_URL}api/v1/users/crime/all`);
//                 console.log("res: crime : ",res,res.data)
//                 if (!mounted) return;
//                 const fetchedData = res.data.data[0] || defaultData;
//                 console.log("Fetched crime data:", fetchedData);
//                 setData(fetchedData);
//             } catch (err) {
//                 console.error("Error fetching crime:", err);
//                 setData(defaultData);
//             } finally {
//                 if (mounted) setLoading(false);
//             }
//         };
//         fetchData();
//         return () => {
//             mounted = false;
//         };
//     }, []);

//     if (loading) {
//         return <div>Loading...</div>;
//     }

//     return (
//         <>
//             <section className="section-space-bottom-less30 mt-lg-5">
//                 <div className="container">
//                     <div className="row">
//                         <div className="col-lg-8 col-md-12 mb-30">
//                             <div className="topic-border color-cod-gray mb-30">
//                                 <div className="topic-box-lg color-cod-gray">{data.main_news?.featured?.title}</div>
//                             </div>
//                             <div className="img-overlay-70 img-scale-animate">
//                                 <img src={data.main_news?.featured?.image} alt="news" className="img-fluid" />
//                                 <div className="mask-content-lg">
//                                     <div className="topic-box-sm color-cod-gray mb-20 hidden-mb">National News</div>
//                                     <div className="post-date-light">
//                                         <ul>
//                                             <li>
//                                                 <span>
//                                                     <i className="fa fa-calendar" style={{ color: "black" }} aria-hidden="true" />
//                                                 </span>{new Date(data.main_news?.featured?.date).toLocaleDateString()}
//                                             </li>
//                                         </ul>
//                                     </div>
//                                     <h2 className="title-medium-light size-xl d-none d-sm-block">
//                                         <Link to="/news-info">{data.main_news?.featured?.category}</Link>
//                                     </h2>
//                                 </div>
//                             </div>
//                             <div className="item-box-light-md-less30 ie-full-width">
//                                 {data.main_news?.list?.map((item, index) => (
//                                     <div key={index} className="media mb-30 media-none--sm">
//                                         <div className="position-relative width-40">
//                                             <Link to="/news-info" className="img-opacity-hover">
//                                                 <img src={item.image} alt="news" className="img-fluid" />
//                                             </Link>
//                                             <div className="topic-box-top-xs">
//                                                 <div className="topic-box-sm color-cod-gray mb-20">{item.category}</div>
//                                             </div>
//                                         </div>
//                                         <div className="media-body p-mb-none-child media-margin30">
//                                             <div className="post-date-dark">
//                                                 <ul>
//                                                     <li>
//                                                         <span>
//                                                             <i className="fa fa-calendar" style={{ color: "black" }} aria-hidden="true" />
//                                                         </span>{new Date(item.date).toLocaleDateString()}
//                                                     </li>
//                                                 </ul>
//                                             </div>
//                                             <h3 className="title-semibold-dark size-lg mb-15 mb5-md">
//                                                 <Link to="/news-info">{item.title}</Link>
//                                             </h3>
//                                             <p>{item.description}</p>
//                                         </div>
//                                     </div>
//                                 ))}
//                             </div>
//                         </div>

//                     </div>
//                 </div>
//             </section>
//         </>
//     );
// };

// export default Crime;






import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const HomeCrime = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  // ---------- DEFAULT STATIC DATA ----------
  const defaultData = {
    main_news: {
      featured: {
        title: "अपराध",
        category: "यमुनोत्री जाते समय चलती कार में गिरा पहाड़: 3 लोग सवार...",
        date: "2017-03-22T17:49",
        // image: "/assets/img/ezgif-5530dd1da8b37c_1759988348.webp",
        image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766689123/ezgif-5530dd1da8b37c_1759988348_zs5bii.webp"
      },

      list: [
        {
          title: "जहरीला कफ सिरप बनाने वाली कंपनी का डायरेक्टर गिरफ्तार",
          // image:
          //   "/assets/img/live-update-centre-2025-10-09t081936484_1759978108.webp",
          image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688154/live-update-centre-2025-10-09t081936484_1759978108_amjvky.webp",
          category: "News",
          date: "2017-03-22T17:50",
          description:
            "मध्य प्रदेश में 23 बच्चों की मौत का कारण बने कोल्ड्रिफ कफ सिरप...",
        },
        {
          title: "हरियाणा IPS सुसाइड केस; 2 धड़ों में बंटे अफसर",
          // image: "/assets/img/ezgif-25eec5267e400a_1759978236.webp",
          image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688163/ezgif-25eec5267e400a_1759978236_l0w35c.webp",
          category: "News",
          date: "2017-03-22T02:34",
          description:
            "हरियाणा के IPS अफसर IG वाई पूरन कुमार का सुसाइड केस अब तूल पकड़ता...",
        },
        {
          title: "नागपुर से मिला था छिंदवाड़ा को ‘मौत का अलर्ट’",
          // image: "/assets/img/11-1_1759952360.webp",
          image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688163/11-1_1759952360_dcagf4.webp",
          category: "News",
          date: "2017-03-22T02:34",
          description:
            "छिंदवाड़ा में कोल्ड्रिफ कफ सिरप से हुई मौतें टाली जा सकती थी...",
        },
      ],
    },
  };

  // ---------- FETCH DATA ----------
  useEffect(() => {
    let mounted = true;

    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL}api/v1/users/crime/all`
        );

        if (!mounted) return;

        const fetchedData = res?.data?.data?.[0] || defaultData;
        setData(fetchedData);
      } catch (err) {
        console.log("Fetch error:", err);
        setData(defaultData);
      } finally {
        if (mounted) setLoading(false);
      }
    };

    fetchData();
    return () => (mounted = false);
  }, []);

  if (loading) return <div>Loading...</div>;

  const featured = data.main_news?.featured;
  const list = data.main_news?.list || [];

  return (
    <section className="section-space-bottom-less30 mt-lg-5">
      <div className="container">
        {/* ---------- SECTION TITLE ---------- */}
        <div className="topic-border color-cod-gray mb-30">
          <div className="topic-box-lg color-cod-gray">{featured?.title}</div>
        </div>

        {/* ---------- FEATURED CRIME NEWS ---------- */}
        <div className="featured-news-card mb-5">
          <img
            src={
              Array.isArray(featured?.image)
                ? featured.image[0]
                : featured?.image
            }
            alt="featured"
            className="featured-image"
            onError={(e) => (e.target.src = "/assets/img/placeholder.jpg")}
          />

          <div className="featured-overlay">
            <span className="cat-badge">{featured?.title}</span>

            <h1 className="featured-title">
              <Link to="/news_info">{featured?.category}</Link>
            </h1>

            <p className="featured-date" style={{ fontSize: "16px", fontFamily: "sans-serif" }}>
              <i className="fa fa-calendar" style={{ fontSize: "20px", color: "", margin: "8px", }}></i>{" "}
              {new Date(featured?.date).toLocaleDateString("hi-IN")}
            </p>

            <i className="fa fa-share-alt" style={{ fontSize: "25px", color: "", margin: "10px" }} />
            <i className="fa fa-thumbs-o-up" style={{ fontSize: "25px", color: "white", margin: "10px" }} />
            <i className="fa fa-commenting-o" style={{ fontSize: "25px", color: "white", margin: "10px" }} />

          </div>
        </div>

        {/* ---------- CRIME NEWS LIST ---------- */}
        <div className="row" style={{marginTop:"40px"}}>
          {list.map((item, index) => (
            <div key={index} className="col-lg-4 col-md-6 col-sm-12 mb-4">
              <div className="news-card">
                <Link to="/news_info">
                  <img
                    src={
                      Array.isArray(item.image) ? item.image[0] : item.image
                    }
                    alt="news"
                    className="news-img"
                    onError={(e) =>
                      (e.target.src = "/assets/img/placeholder.jpg")
                    }
                  />
                </Link>

                <div className="news-content">
                  <span className="news-cat">{item.category}</span>

                  <h3 className="news-title">
                    <Link to="/news_info">{item.title}</Link>
                  </h3>

                  <p className="news-desc">{item.description}</p>

                  <p className="news-date" style={{ fontSize: "20px", color: "black", fontFamily: "sans-serif" }}>
                    <i className="fa fa-calendar"></i>{" "}
                    {new Date(item.date).toLocaleDateString("hi-IN")}
                    <i className="fa fa-share-alt" style={{ fontSize: "25px", color: "black", margin: "10px" }} />
                    <i className="fa fa-thumbs-o-up" style={{ fontSize: "25px", color: "black", margin: "10px" }} />
                    <i className="fa fa-commenting-o" style={{ fontSize: "25px", color: "black", margin: "10px" }} />

                  </p>

                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeCrime;

